<template>
  <Modal
    title="Logs de alterações"
    :active.sync="activeModal"
    @close="close"
    fullscreen
  >
    <vs-row class="mb-6 divider" v-for="(item, index) in logs" :key="index">
      <vs-col
        ><span class="text-xl font-bold text-black">{{ item.data }}</span>
        <vs-row
          class="mb-4 flex flex-row"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-1/12 w-full`"
            ><span class="text-lg font-semibold">Ação</span
            ><span class="word-break">{{ itemDados.action }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-1/12 w-full`"
            ><span class="text-lg font-semibold">Sucesso</span
            ><span class="word-break">{{
              getYesOrNo(itemDados.result)
            }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-1/12 w-full`"
            ><span class="text-lg font-semibold">Campo</span
            ><span class="word-break">{{ itemDados.field }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-2/12 w-full`"
            ><span class="text-lg font-semibold">Anterior</span
            ><span class="word-break">{{
              itemDados.oldColumnData
            }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-2/12 w-full`"
            ><span class="text-lg font-semibold">Posterior</span
            ><span class="word-break">{{
              itemDados.newColumnData
            }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-3/12 w-full`"
            ><span class="text-lg font-semibold">Mensagem</span
            ><span class="word-break">{{ itemDados.message }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-1/12 w-full`"
            ><span class="text-lg font-semibold">{{
              itemDados.isProspect ? 'Associado' : 'Usuário'
            }}</span
            ><span class="word-break">{{ itemDados.userName }}</span></vs-col
          >
          <vs-col
            :class="`flex flex-col ${aplicaBackgroud(
              indexDados,
            )} lg:w-1/12 w-full`"
            ><span class="text-lg font-semibold">Hora</span
            ><span class="word-break">{{ itemDados.hora }}</span></vs-col
          >
        </vs-row>
      </vs-col>
    </vs-row>
  </Modal>
</template>
<script>
import Modal from '../../../../../components/Modal.vue';
import utilsList from '../../../../../utils/list';

export default {
  name: 'BrokerPreRegisterLogs',
  components: {
    Modal,
  },
  props: ['logs', 'active'],
  data() {
    return {
      activeModal: false,
      getYesOrNo: utilsList.getSimNao,
    };
  },
  watch: {
    active(newValue) {
      this.activeModal = newValue;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    aplicaBackgroud(index) {
      return index % 2 === 0 ? 'background' : '';
    },
  },
};
</script>
<style scoped>
.divider {
  border: 0.1rem solid #e3e3e3;
}

.background {
  background: #e7e7e7;
}

.word-break {
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
